import { createSlice } from "@reduxjs/toolkit";

const DeliveryAddressSlice = createSlice({
  name: "deliveryAddress",
  initialState: {
    isLoading: false,
    listAddress:[],
    addressData:null
  },
  reducers: {
    addAddressRequest: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    addAddressSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        // addressData:action.payload
      };
    },
    addAddressFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    deleteAddressRequest: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    deleteAddressSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    deleteAddressFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    listAddressRequest: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    listAddressSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        listAddress:action.payload
      };
    },
    listAddressFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    viewAddressRequest: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    viewAddressSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        addressData:action.payload
      };
    },
    viewAddressFailure: (state, action) => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

export const {
  addAddressRequest,
  addAddressFailure,
  addAddressSuccess,
  deleteAddressFailure,
  deleteAddressRequest,
  deleteAddressSuccess,
  listAddressFailure,
  listAddressRequest,
  listAddressSuccess,
  viewAddressFailure,
  viewAddressRequest,
  viewAddressSuccess
} = DeliveryAddressSlice.actions;

export default DeliveryAddressSlice.reducer;
